import { createContext } from 'react'
import { Role } from '../types'

type ContextProps = {
  authState: {
    authUser: {
      id: string
      role_id: number
      department_id: string
      email: string
      first_name?: string
      last_name?: string
      site_admin: boolean
      department?: {
        id: string
        name: string
      }
      branch: string
      impersonated_by?: string
      user_role?: Role
    }
    authToken: string
    initializing: boolean
  }
  signIn: (token: string) => void
  signOut: () => void
}

const AuthContext = createContext<ContextProps>({
  authState: {
    authUser: {
      id: '',
      role_id: 0,
      site_admin: false,
      first_name: '',
      last_name: '',
      branch: '',
      department_id: '',
      email: '',
      impersonated_by: '',
    },
    authToken: '',
    initializing: false,
  },
  signIn: (token) => {},
  signOut: () => {},
})

export default AuthContext
